/*
 * Normalize TanStack Form field errors to strings.
 * `field.state.meta.errors` entries can be plain strings (from a string
 * validator) or objects with a `message` (from a Standard Schema / Zod
 * validator). This flattens both to a string[] for display.
 */
export function fieldErrorMessages(errors: ReadonlyArray<unknown>): string[] {
  return errors
    .map((e) => {
      if (typeof e === 'string') return e;
      if (e && typeof e === 'object' && 'message' in e) {
        const m = (e as { message?: unknown }).message;
        return typeof m === 'string' ? m : undefined;
      }
      return undefined;
    })
    .filter((m): m is string => Boolean(m));
}
